const swichLang = (namesArray, namesArrayEn) => {

  const textsRu = document.querySelectorAll('.ru');
  const textsEn = document.querySelectorAll('.en');

  

  const toggle=document.getElementById("toggle");
  const flag=document.getElementById("flag");

  if (localStorage.getItem("Language") === 'english') {
    flag.classList.remove('russian');
    flag.classList.add('english');
    flag.src="https://flagicons.lipis.dev/flags/4x3/gb.svg";

    textsEn.forEach(text => {
      text.style.display = 'block';
    })
    textsRu.forEach(text => {
      text.style.display = 'none';
    })
  } else {
    if (flag.classList.contains('english')) {
      flag.classList.remove('english');
      flag.classList.add('russian');
      flag.src="https://flagicons.lipis.dev/flags/4x3/ru.svg";

      textsEn.forEach(text => {
        text.style.display = 'none';
      })
      textsRu.forEach(text => {
        text.style.display = 'block';
      })
    }
  }


  function switchLang(){
    //en to ru
    if (flag.classList.contains('english')) {
      flag.classList.remove('english');
      flag.classList.add('russian');
      flag.src="https://flagicons.lipis.dev/flags/4x3/ru.svg";

      textsEn.forEach(text => {
        text.style.display = 'none';
      })
      textsRu.forEach(text => {
        text.style.display = 'block';
      })

      localStorage.setItem("Language", flag.classList.value);
    
    }
    //ru to en
    else {
      flag.classList.remove('russian');
      flag.classList.add('english');
      flag.src="https://flagicons.lipis.dev/flags/4x3/gb.svg";

      textsEn.forEach(text => {
        text.style.display = 'block';
      })
      textsRu.forEach(text => {
        text.style.display = 'none';
      })

      localStorage.setItem("Language", flag.classList.value);
    }

    
  }

  

  
toggle.addEventListener('click', switchLang);
}

export default swichLang;